import type { Provider } from '@angular/core'
import * as Sentry from '@sentry/angular'

import { LOG_SINK } from './logger.service'
import type { FrontendLogLevel, LogSink } from './logger.service'

const SEVERITY: Record<FrontendLogLevel, Sentry.SeverityLevel> = {
  debug: 'debug',
  info: 'info',
  warn: 'warning',
  error: 'error',
}

/**
 * Routes log records into Sentry: every call becomes a breadcrumb, and errors are captured with
 * their stack intact.
 *
 * Provide this in apps that initialise Sentry. Apps that do not - the embeddable elements build -
 * simply leave LOG_SINK unbound and the logger degrades to console only.
 */
export const sentryLogSink: LogSink = {
  breadcrumb(level, message, data) {
    Sentry.addBreadcrumb({ category: 'app', level: SEVERITY[level], message, data })
  },
  capture(error, data) {
    // captureException, not captureMessage: it is what preserves the stack and gives Sentry
    // something stable to group on. An ApiError's reqId is tagged by `tagApiError` (beforeSend),
    // which sees every capture path, not only this one.
    Sentry.captureException(error, (scope) => {
      if (data) scope.setExtras(data)
      return scope
    })
  },
}

export const provideSentryLogSink = (): Provider => ({ provide: LOG_SINK, useValue: sentryLogSink })
